export default "__VITE_ASSET__DZ25mHNb__"